// extracted by mini-css-extract-plugin
module.exports = {"externalId":"_275dqMJWFIo1EMO7aoP4mY"};